import { render, staticRenderFns } from "./Diagnosis.vue?vue&type=template&id=1dc8d821&"
import script from "./Diagnosis.vue?vue&type=script&lang=js&"
export * from "./Diagnosis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports